import {
  CandidatePositionStatusBuilder,
  GetCandidatePositionHistoryInput,
  GetCandidatePositionHistoryOutput,
} from '../candidate-position-status.types';

export const getCandidatePositionHistory = (
  builder: CandidatePositionStatusBuilder
) =>
  builder.query<
    GetCandidatePositionHistoryOutput,
    GetCandidatePositionHistoryInput
  >({
    query: ({ candidateId }) => ({
      url: `candidate-position-status/candidate/${candidateId}/positions`,
      method: 'GET',
    }),
    providesTags: ['CandidatePositionHistory'],
  });
